var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasklist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_478_1416",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_478_1416",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACV0lEQVR4nO2cwYoTQRRFa6X+gUb9H5mFy6wDSb8bCEZXMx1/cNSV+ikygvaqpKAXQTJS3Sb9qjrnQEFWnXD65lbnESoEAAAAAAAAAAAAAAAAODOr1eqZmX0wsy+SfkqKLMXexWdJ7/f7/dP/ktw0zWtJ3xGrf4bLzL4lV6OTjGQNkj0q2akuSLKG1uR+jOjUyfSxBjn4NEb0A6I1KGjJ2WDR55JsZr8ltbvd7kVa6bWkbq430UV0kmxmNyeuffAWMifRKbVvT117s9k89xYyF9GPSk6s1+uX3kKqF/1YXRxjZh+9hVQtOlPyTb9BukupRnQv7FbSIuealie5M7O7VC+hAPqay35SGvwGmXfwNvd6lp/kNhRIL9tHdHouzrlW0zRvJP3KvHlZ346p6X8DuCV6cWbJsZTK+JvtdvvKs6PvLrDxtaFAcn9kXWwzPLVx9RvIYeTTRZdkl5LsUjZDlhAdPYJAooXoOKcKItFCdPROIYmWvziqQ/5S6WghOmZIYEw6UVLaUCCuY9ILrUUoEO8x6dnXupBhUlFj0iurjsPcRHeMSf3kx1pWTYmONS9EC9HRO4UkWv7iqA75S6WjhejonTgSLX9J11YdHf8mve5ZRzu3RC9CgTAmnQjGpBPBmPTC8G9S+T/K1b4ZxpoXooXo6J1CEi1/cVSHZtLRHIyiwZLN7McY0Rz1owmO+knnuXl/DVXZMrN3g0Wno8XSEWPeH171rK/L5fJJGEM6NA/ZypKchk6jJB8nO53nlvqHDVLHNfFgZvepLkYnGQAAAAAAAAAg1Mkf6vOHuuMKDFsAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasklist);
export default __webpack_public_path__ + "static/media/Tasklist.40cd7ba7b812c19f96cc93e98a80ee65.svg";
export { ForwardRef as ReactComponent };